import {ConfigContext, ConfigDispatch} from "../context/ConfigContext";
import React, {useContext, useState} from "react";
import {TextSectionsDispatch, TextSectionsListContext} from "../context/TextSectionsListContext";
import {AppNavigation} from "./AppNavigation";
import PdfRenderer from "./PdfDocument";
import {ToolbarActions} from "./TolbarActions";
//wyswig editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {Editor} from "react-draft-wysiwyg";
import Price from "./Price";
import Modal from "./Modal";
import {WorkingSizeContext} from "../context/WorkingSizeContext";
import WorkingSizeSelector from "./WorkingSizeSelector";
import {calculateGridLines} from "../services/helpers";
import {useLanguage} from "../context/LanguageContext";

export const TextSectionsList = () => {
    const {t, language} = useLanguage();
    const config = useContext(ConfigContext);
    const configDispatch = useContext(ConfigDispatch);
    const textSectionDispatch = useContext(TextSectionsDispatch);
    const textSection = useContext(TextSectionsListContext);
    const workingSize = useContext(WorkingSizeContext);
    const getListContent = () => {
        return textSection.map((section) => {
            return section.content;
        });
    }

    const currentSection = textSection.length > 0 ? textSection.find((section) => section.active) : null;
    const listContent = getListContent();

    // Calculate grid lines based on canvas dimensions and grid spacing
    const gridLines = workingSize?.widthCm && workingSize?.heightCm && config.gridSpacingCm
        ? calculateGridLines(workingSize.widthCm, workingSize.heightCm, config.gridSpacingCm)
        : { verticalLines: [], horizontalLines: [] };

    function deactivateItem(e) {
        textSectionDispatch({
            type: 'updateTextSectionActive',
            payload: {
                index: currentSection.index,
                active: false
            }
        });
    }

    async function deactivateAllTextSectionsAndAddNewOne(e) {
        const target = e.target.closest('.text-section__content');
        if (target) {
            return;
        }
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        await deactivateAllTextSections();
        textSectionDispatch({
            type: 'addTextSection',
            payload: {
                position: {
                    x: x,
                    y: y,
                },
                value: '',
                rawContent: '',
                fontSize: config.selectedFontSize,
                fontSizeValue: config.selectedFontSizeObject.slug,
                fontSizeErpId: config.selectedFontSizeObject?.id_erp,
                letterSpacing: config.selectedLetterSpacing,
                textAlign: 'left',
                active: true
            }
        });
    }

    async function addNewTextSection() {
        await deactivateAllTextSections();
        const listElement = document.querySelector('.text-sections-list');
        let x = config.additionalWorkingSizeMargin / 2;
        let y = config.additionalWorkingSizeMargin / 2;

        textSectionDispatch({
            type: 'addTextSection',
            payload: {
                position: {
                    x: x,
                    y: y,
                },
                value: '',
                rawContent: '',
                fontSize: config.selectedFontSize,
                fontSizeValue: config.selectedFontSizeObject.slug,
                fontSizeErpId: config.selectedFontSizeObject?.id_erp,
                letterSpacing: config.selectedLetterSpacing,
                textAlign: 'left',
                active: true
            }
        });
    }

    const deactivateAllTextSections = () => {
        return new Promise((resolve) => {
            textSectionDispatch({
                type: 'deactivateAllTextSections'
            });
            textSectionDispatch({
                type: "removeEmptyTextSections"
            });
            resolve();
        })
    }

    const toolbarOptions = {
        "options": [],
    }

    const toolbarCustomButtons = [
        <ToolbarActions
            index={currentSection ? currentSection.index : 0}
            onDeactivateItem={deactivateItem}
            fontSize={config.selectedFontSize}
            letterSpacing={config.selectedLetterSpacing}
        />
    ]

    return (
        <div className="row" style={{flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center'}}>
            <div className="col-8">
                <WorkingSizeSelector/>
            </div>
            <div className="col-12">
                {/*OBSZAR ROBOCZY - nawigacja*/}
                <div
                    id={"workingArea"}
                    style={{
                        position: 'relative',
                        margin: 'auto',
                        // Obszar jest co najmniej tak szeroki jak płótno (+ margines), ale rośnie
                        // razem z paskiem narzędzi, żeby pasek i szare tło miały tę samą szerokość.
                        // Samo płótno (.text-sections-list) zachowuje swój rozmiar — pozycje sekcji
                        // i siatka liczą się względem niego.
                        width: 'max-content',
                        maxWidth: 'calc(100vw - 2rem)',
                        minWidth: workingSize?.widthPx ? `${workingSize.widthPx + config.additionalWorkingSizeMargin}px` : undefined,
                    }}
                >
                    <div className={'editor_top'}>
                        <Editor
                            localization={{
                                locale: language,
                            }}
                            toolbar={toolbarOptions}
                            toolbarCustomButtons={toolbarCustomButtons}
                            ariaLabel={t('textSection.textEditor')}
                        />
                    </div>
                    {/* Szare tło o szerokości paska narzędzi; płótno wyśrodkowane w środku */}
                    <div className="text-sections-list__outer">
                        <div
                            style={{
                                position: 'relative',
                                fontFamily: config.selectedFont,
                                fontSize: '2rem',
                                width: workingSize?.widthPx ? `${workingSize.widthPx + config.additionalWorkingSizeMargin }px` : undefined,
                                height: workingSize?.heightPx ? `${workingSize.heightPx + config.additionalWorkingSizeMargin }px` : undefined,
                            }}
                            className="text-sections-list"
                            aria-label={t('textSection.textSectionsList')}
                            role="region"
                        >
                            {/*Widok roboczy z siatką */}
                            <div
                                id="workingAreaGrid"
                                style={{
                                    backgroundColor: '#fff',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: `translate(-50%, -50%)`,
                                    zIndex: 0,
                                    content: '""',
                                    width: workingSize?.widthPx ? `${workingSize.widthPx}px` : undefined,
                                    height: workingSize?.heightPx ? `${workingSize.heightPx}px` : undefined,
                                }}
                            >
                                {/* Render vertical grid lines */}
                                {config.showGrid && gridLines.verticalLines.map((position, index) => (
                                    <div
                                        key={`v-${index}`}
                                        style={{
                                            position: 'absolute',
                                            left: `${position * workingSize.scale}px`,
                                            top: 0,
                                            width: '1px',
                                            height: '100%',
                                            backgroundColor: 'rgba(204, 204, 204, 0.5)',
                                            pointerEvents: 'none',
                                        }}
                                    />
                                ))}
                                {/* Render horizontal grid lines */}
                                {config.showGrid && gridLines.horizontalLines.map((position, index) => (
                                    <div
                                        key={`h-${index}`}
                                        style={{
                                            position: 'absolute',
                                            left: 0,
                                            top: `${position * workingSize.scale}px`,
                                            width: '100%',
                                            height: '1px',
                                            backgroundColor: 'rgba(204, 204, 204, 0.5)',
                                            pointerEvents: 'none',
                                        }}
                                    />
                                ))}
                            </div>
                            <button onClick={addNewTextSection} className="btn btn--add-section btn--secondary">+</button>
                            {listContent}
                            <Modal/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <AppNavigation/>
            </div>
            <div className="col-12">
                <Price/>
            </div>
            <div className="col-12">
                <PdfRenderer/>
            </div>
        </div>
    )
}
